import { Component, HostListener, Inject, OnDestroy, OnInit, NgZone } from '@angular/core';
import { Store } from '../../store';
import { AuthService } from '../../services/auth.service';
import { AlertService } from '../../services/alert.service';
import { Router } from '@angular/router';
import { OverlayService } from '../../services/overlay.service';
import { ChatService } from '../../services/chat.service';
import { NotificationService } from '../../services/notification.service';
import { UserService } from '../../services/user.service';
import { SitesService } from '../../upero-cms/services/sites.service';
import { SitesSelectionService } from '../../services/sites-selection.service';
import { debounce, filter } from 'rxjs/operators';
import { ToolsService } from '../../services/tools.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TwilioService } from 'src/app/services/twilio.service';
import { Subject, Subscription, timer } from 'rxjs';
import { GlobalSearchService } from '../../global-search/global-search.service';
import { DOCUMENT } from '@angular/common';
import { PaymentsService } from '../../services/payments.service';
import { ChatReminderService } from './../../chat/services/reminder.service';
import { ChatRESTService } from 'src/app/chat/services/chat-rest.service';
import { ChatGroupLogicService } from 'src/app/chat/services/chat-group-logic.service';
import { ChatSocketService } from 'src/app/chat/services/chat-socket.service';
import { AlertConfirmable } from '../../decorators/alert-confirmable.decorator';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    animations: [
        trigger('slideIn', [
            state('void', style({ height: '0', opacity: '0.4' })),
            transition('void <=> *', [animate('100ms ease-out')]),
        ]),
    ],
})
export class HeaderComponent implements OnInit, OnDestroy {
    user$ = this.store.select<any>('user');
    notifications$ = this.store.select<any>('notifications');
    chatStore$ = this.store.select<any>('chatStore');
    hideMenu$ = this.store.select<boolean>('hideMenu');

    user = this.store.selectForLocal('user');

    sites: any;
    selectedSite: any;
    modules = this.store.selectForLocal('modules');

    myTwilioAgent$$: Subscription = null;

    activityMonitor$ = new Subject();
    activityMonitor$$: Subscription = null;
    private deferredHeaderStartup: ReturnType<typeof setTimeout> = null;

    @HostListener('document:mousemove', ['$event'])
    onMousemoveHandler(event: KeyboardEvent) {
        this.activityMonitor$.next('mousse');
    }

    @HostListener('document:keydown', ['$event'])
    onKeydownHandler(event: KeyboardEvent) {
        this.activityMonitor$.next('keyboard');
    }

    constructor(
        public twilioService: TwilioService,
        private store: Store,
        private authService: AuthService,
        private alertService: AlertService,
        private router: Router,
        private overlayService: OverlayService,
        private chatService: ChatService,
        public notificationService: NotificationService,
        private userService: UserService,
        private sitesService: SitesService,
        private sitesSelectionService: SitesSelectionService,
        private toolsService: ToolsService,
        private globalSearchService: GlobalSearchService,
        private paymentsService: PaymentsService,
        private chatReminderService: ChatReminderService,
        private chatRESTService: ChatRESTService,
        private chatGroupLogicService: ChatGroupLogicService,
        private chatSocketService: ChatSocketService,
        @Inject(DOCUMENT) private document: Document
    ) {}

    ngOnInit(): void {
        this.userService.getByToken().subscribe((userData) => {
            if (userData) {
                this.deferredHeaderStartup = setTimeout(() => {
                    this.chatService.receiveUserOnlineStatus();
                    this.chatService.receiveTypingSignal();
                    this.notificationService.listenToNotifications(userData);
                    this.notificationService.getUnfilteredNotifications().subscribe();
                    this.chatReminderService.initReminders();

                    this.chatRESTService.getChatList().subscribe((chats) => {
                        this.chatGroupLogicService.chats = chats;
                    });
                    this.chatSocketService.setupListenSocketEvents();
                }, 8000);
            } else {
                this.router.navigate(['']);
            }
        });

        this.sitesService.getSites().subscribe((sites) => {
            this.sites = sites;
            if (this.sites && this.sites.length > 0) {
                this.sitesSelectionService.site = this.sites[0];
                this.sitesSelectionService.selectedSite.subscribe((nextValue) => {
                    this.selectedSite = nextValue;
                });
            }
        });

    }

    logout() {
        this.chatService.sendOfflineSignal();
        this.twilioService.destroyDevices();
        this.authService.logout().subscribe(() => {
            this.router.navigate(['/']);
        });
    }

    @AlertConfirmable({
        title: 'Logout',
        message: 'Are you sure you want to logout?',
        cancelText: 'No',
    })
    logoutConfirmation() {
        this.logout();
    }

    toggleNotifications() {
        this.overlayService.toggle('notifications');
    }

    toggleMenu() {
        let hideMenu = this.store.selectForLocal('hideMenu');
        hideMenu = !hideMenu;
        this.store.set('hideMenu', hideMenu);
    }

    enableInboundCalls(timeout?: number): void {
        this.disableActivityMonitor();

        if (timeout) {
            this.activityMonitor$$ = this.activityMonitor$
                .pipe(debounce(() => timer(timeout)))
                .subscribe((data) => this.twilioService.inboundCallsDnd(true));
        }

        this.twilioService.inboundCallsDnd(false);
    }

    disableInboundCalls(): void {
        this.disableActivityMonitor();
        this.twilioService.inboundCallsDnd(true);
    }

    private disableActivityMonitor() {
        if (this.myTwilioAgent$$) {
            this.myTwilioAgent$$.unsubscribe();
        }
        if (this.activityMonitor$$) {
            this.activityMonitor$$.unsubscribe();
            this.activityMonitor$$ = null;
        }
    }

    public daysToDate(date: string): number {
        return date && this.toolsService.datediff(Date.now(), new Date(date).getTime());
    }

    setSite(site: any) {
        this.sitesSelectionService.site = site;
    }

    ngOnDestroy(): void {
        if (this.deferredHeaderStartup) {
            clearTimeout(this.deferredHeaderStartup);
        }
        if (this.myTwilioAgent$$) {
            this.myTwilioAgent$$.unsubscribe();
        }
    }
}
